import React from 'react';
import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import './styles.less';

const { Text, Title } = Typography;

const DocWarning = ({ onOk, onCancel, profileTypeId }) => {
  const { t } = useTranslation();

  const handleOkClick = () => {
    onOk();
  };

  const handleCancelClick = () => {
    onCancel();
  };

  const handleDocumentationClick = () => {
    window.open(
      `${t('urls.appDocUrl', { provider: profileTypeId.toLowerCase() })}#application`,
      '_blank',
      'noreferrer',
    );
  };

  return (
    <div className="doc-warning-container">
      <Title level={4}>{t('docWarning.title')}</Title>
      <Text>
        {t('docWarning.textPartOne')}
        <br />
        {t('docWarning.textPartTwo')}
        <br />
        {t('docWarning.textPartThree')}
      </Text>
      <div className="doc-warning-container__buttons-container">
        <Button className="doc-warning-container__button" onClick={handleDocumentationClick}>
          {t('docWarning.docButton')}
        </Button>
        <Button
          className="doc-warning-container__button"
          type="primary"
          onClick={handleOkClick}
          autoFocus
        >
          {t('docWarning.continueButton')}
        </Button>
      </div>
      <Button type="link" onClick={handleCancelClick}>
        {t('docWarning.goBackButton')}
      </Button>
    </div>
  );
};

DocWarning.propTypes = {
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  profileTypeId: PropTypes.string.isRequired,
};

export default DocWarning;
